/**
 * Modella il JSON per effettuare il login.
 */
export class LoginRequest {
  public readonly emailAddress: string;
  public readonly password: string;

  constructor(emailAddress: string, password: string) {
    this.emailAddress = emailAddress;
    this.password = password;
  }
}
